import { ButtonContainer } from "./styles";

const SeeAllResultsButton = ({ className, inputValue, onSearch }) => {
  if (!inputValue?.length) return <></>;

  return (
    <ButtonContainer
      className={`bn-search__results-btn ${className}`}
      onClick={() => onSearch()}
    >
      Pesquisar por "{inputValue}"
    </ButtonContainer>
  );
};

export default SeeAllResultsButton;
